import React from "react";
import styled from "styled-components";

const ErrorText = styled.div`
  color: red;
  font-size: 14px;
`;

const InputWithLabel = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  width: ${({ customWidth }) => (customWidth ? customWidth : "100%")};
  margin-bottom: 0px;
  margin-left: ${({ isNotFirst }) => isNotFirst && "20px"};
`;
const StyledInput = styled.input`
  border: none;
  box-sizing: border-box;
  height: 40px;
  border: ${({ companySearch }) => companySearch && "1px solid rgba(43, 61, 80, 0.1)"};
  border-radius: ${({ companySearch }) => companySearch && "3px"};
  width: ${({ companySearch }) => companySearch && "100%"};
  border-bottom: ${({ theme, companySearch }) =>
    !companySearch && `2px solid ${theme.secondaryGrayColor}`};
  font-size: 14px;
  padding: 0 8px;
  margin-bottom: 8px;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:focus {
    outline: none;
    border-color: ${({ companySearch, theme }) => companySearch && theme.primaryColor};
  }
`;
const Label = styled.label`
  padding-bottom: ${({ companySearch }) => companySearch && "0.5%"};
  font-size: ${({ companySearch }) => (companySearch ? "13px" : "14px")};
  color: ${({ companySearch, theme }) => (companySearch ? theme.black75 : "#0d193b")};
  font-weight: bold;
  line-height: 2;
`;

export default function SingleInput({
  label,
  value,
  type,
  reg,
  name,
  errors,
  onChange,
  placeholder,
  companySearch,
  customWidth,
  isNotFirst,
  style,
  inputStyle,
  checked,
}) {
  const error = name ? errors[name] : "";
  return (
    <>
      <InputWithLabel customWidth={customWidth} isNotFirst={isNotFirst} style={{ ...style }}>
        <Label
          companySearch={companySearch}
          htmlFor={label ? `input_for_${label}` : null}
        >
          {label}
        </Label>
        <StyledInput
          checked={checked}
          autoComplete="off"
          companySearch={companySearch}
          placeholder={placeholder}
          id={label ? `input_for_${label}` : null}
          name={name}
          ref={reg}
          type={type ? type : "text"}
          value={value}
          onChange={onChange}
          style={inputStyle}
        />
        <ErrorText>{error && error.message}</ErrorText>
      </InputWithLabel>
    </>
  );
}
